import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import { Link, withRouter } from "react-router-dom";

// import "../../styles/css/users/CompanyUserMgt.css";
import "../../styles/css/ElevationForm/elevationForm.css";

import API from "../../api/api";
import "filepond/dist/filepond.min.css";
import axios from "axios";

// sb sections
import TabComponents from "./TabComponents";
import SectionA from "./SectionA";
import SectionB from "./SectionB";
import SectionC from "./SectionC";
import SectionD from "./SectionD";
import SectionE from "./SectionE";
import SectionF from "./SectionF";
import SectionG from "./SectionG";
import SectionH from "./SectionH";

import Loader from "./Loader";

import SimpleReactValidator from "simple-react-validator";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import qs from "qs";

const MySwal = withReactContent(Swal);

const token = localStorage.getItem("token");
const userRole = localStorage.getItem("userRole");

const userId = localStorage.getItem("userId");

const API_URL2 =
  "https://gis.suffolkcountyny.gov/server/rest/services/Locators/AddressMultiRole/GeocodeServer/findAddressCandidates?SingleLine=";

const API_URL3 =
  "https://gisservices2.suffolkcountyny.gov/arcgis/rest/services/Live_Layers_External/MapServer/57/query?f=json&returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=%7B%22";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#ffffff",
    boxShadow: "none",
    color: "#606060",
  },
  indicator: {
    backgroundColor: "#00aeef",
  },
  selected: {
    color: "#00aeef",
  },

  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
});

class ElevationForm extends Component {
  constructor(props) {
    var today = new Date(),
      date =
        today.getDate() + "/" + today.getMonth() + "/" + today.getFullYear();
    super(props);
    this.state = {
      checkedA: false,
      currentstep: parseInt(sessionStorage.getItem("active_section")),

      address: "",
      files: [],
      loading: false,

      query: "",
      options: [],
      isLoading: true,
      // selected: "",
      addressLine: [],
      floodZone: "",
      geoInfo: [],
      userData: [],
      file: null,
      city: "",
      region: "",
      zipcode: "",
      isAddressVerify: false,
      pageA: false,
      isSubmitted: sessionStorage.getItem("form_isSubmitted"),
      isSubmittedA: true,
      isSubmittedB: true,
      isSubmittedC: true,
      isSubmittedD: true,
      isSubmittedE: true,
      isSubmittedF: true,
      isSubmittedG: true,
      isSubmittedH: true,

      stat_val: "",
      mapTaxNo: "",
      fromNotifications: false,
      static_BFE: "",
      v_datum: "",
      degrees: "",
      flood_map_no: "",

      certificate_id: "",

      //section A
      building_owner_name: "",
      dist: "",
      sect: "",
      block: "",
      lot: "",
      building_use: "",
      lattitude: "",
      longitude: "",
      nad_data: "",
      bulding_diagram_no: "",
      sq_ft_crawlspace: "",
      flood_opening_crawlspace: "",
      net_area_crawlspace: "",
      engineered_crawlspace: "",
      sq_ft_garage: "",
      flood_opening_garage: "",
      net_area_garage: "",
      engineered_garage: "",

      //section B

      community_name: "",
      county_name: "",
      map_panel_no: "",
      suffix: "",
      firm_index_date: "",
      effective_date: "",
      fz_source: "",
      fz_other: "",
      elevation_datum: "",
      isLocation: "",
      designation_date: "",
      building_location_area: "",

      //section C
      // building_based: [],
      const_drawings: "",
      under_const: "",
      finished_const: "",

      benchmark_utl: "",
      vertical_datum: "",
      elevation_item: "",
      elevation_other: "",
      top_of_bottom_floor: "",
      top_of_bottom_floor_unit: "",
      top_of_next_floor: "",
      top_of_next_floor_unit: "",
      bottom_of_lowest_member: "",
      bottom_of_lowest_member_unit: "",
      attached_garage: "",
      attached_garage_unit: "",
      attached_garage_top_slab: "",
      attached_garage_top_slab_unit: "",
      lowest_elevation: "",
      lowest_elevation_unit: "",
      lowest_adjacent: "",
      lowest_adjacent_unit: "",
      highest_adjacent: "",
      highest_adjacent_unit: "",
      lowest_adjacent_grade: "",
      lowest_adjacent_grade_unit: "",

      //section D
      Islicensed_surveyor: "",
      profileData: "",
      equipment: [],
      comments_for_D: "",
      user_date: date,
      // user_signature:"",
      certifier_name: "",
      survey_attachment: [],

      certifier_license_no: "",
      certifier_designation: "",
      certifier_company: "",
      certifier_address: "",
      certifier_city: "",
      user_state: "",
      user_signature: "",
      user_zipcode: "",
      user_telephone: "",
      user_ext: "",
      // surveyor_sign: [],
      //section E
      elevation_hag: "",
      elevation_hag_unit: "",
      elevation_lag: "",
      elevation_lag_unit: "",
      permanant_flood_openings: "",
      permanant_flood_openings_unit: "",
      attached_garage_e3: "",
      attached_garage_e3_unit: "",
      equipment_serving: "",
      equipment_serving_unit: "",
      floodplainmgt: "",

      //section F
      owner_name: "",
      owner_address: "",
      owner_city: "",
      owner_state: "",
      owner_zipcode: "",
      owner_signature: "",
      owner_sign_date: date,
      owner_telephone: "",
      owner_comments: "",
      property_attachment: [],
      //section G
      comunity_item: "",
      permit_no: "",
      date_certificate_compliance: "",
      permit_issues_for: "",
      permit_case: "",
      basement_elevation: "",
      basement_elevation_unit: "",
      basement_elevation_datum: "",
      bfe_depth: "",
      bfe_depth_unit: "",
      bfe_depth_datum: "",
      community_design: "",
      community_design_unit: "",
      community_design_datum: "",
      local_officials_name: "",
      local_officials_title: "",
      local_officials_community_name: "",
      local_officials_telephoe: "",
      local_officials_signature: "",
      local_officials_date: "",
      comment_for_community: "",

      item_g1: "",
      item_g2: "",
      item_g3: "",
      //photograhps
      front_view_img: [],
      rear_view_img: [],
      right_view_img: [],
      left_view_img: [],

      front_view_caption: "",
      front_view_date: "",
      rear_view_caption: "",
      rear_view_date: "",
      right_view_caption: "",
      right_view_date: "",
      left_view_caption: "",
      left_view_date: "",

      status: sessionStorage.getItem("section_status"),

      userId: this.props.match.params.id,
      isLoggedUser: false,
      isDashboardLoading: true,
      cardData: "",
      reviews: "",

      value: 0,
      cardOpen: false,

      answer9: "",
      answer1: "",

      attachmentd: "",
      attachmentf: "",
      community_options: [],
      category_code: "",
      blob: "",
    };

    // this.onUploadImage = this.onUploadImage.bind(this);
    // this.onUploadImageF = this.onUploadImageF.bind(this);
  }
  validator = new SimpleReactValidator({});
  validator1 = new SimpleReactValidator({});
  validator2 = new SimpleReactValidator({});
  validator3 = new SimpleReactValidator({});
  validator4 = new SimpleReactValidator({});
  validator5 = new SimpleReactValidator({});
  validator6 = new SimpleReactValidator({});
  validator7 = new SimpleReactValidator({});
  validator8 = new SimpleReactValidator({});

  imagestate = (data) => {
    this.setState({
      survey_attachment: data.map((fileItem) => fileItem.file),
    });
  };
  onChangeProperty = (data) => {
    this.setState({
      property_attachment: data.map((fileItem) => fileItem.file),
    });
  };

  fronViewState = (data) => {
    this.setState({
      front_view_img: data.map((front) => front.file),
    });
  };
  rearViewState = (data) => {
    this.setState({
      rear_view_img: data.map((rear) => rear.file),
    });
  };
  rightViewState = (data) => {
    this.setState({
      right_view_img: data.map((right) => right.file),
    });
  };
  leftViewState = (data) => {
    this.setState({
      left_view_img: data.map((left) => left.file),
    });
  };

  _cache = {};

  //========== modified function =====================//

  getLocationDetails = (address) => {
    this.setState({
      isAddressVerify: true,
    });

    var getAddress = address.map((data) => {
      this.setState({
        addressLine: data,
      });
      return data.text;
    });

    var encodedAddress = qs.stringify(getAddress);

    const getMagicKey = address.map((data) => {
      return data.magicKey;
    });
    axios
      .get(
        `${API_URL2}${encodedAddress}&f=json&outSR=%7B%22wkid%22%3A103120%2C%22latestWkid%22%3A6539%7D&outFields=*&magicKey=${getMagicKey}&maxLocations=6`
      )
      .then((res) => {
        this.setState({
          geoInfo: res.data.candidates[0].attributes,
          city: res.data.candidates[0].attributes.Nbrhd,
          region: res.data.candidates[0].attributes.Region,
          zipcode: res.data.candidates[0].attributes.Postal,
        });

        const X = res.data.candidates.map((data) => {
          return data.attributes.X;
        });
        const Y = res.data.candidates.map((data) => {
          return data.attributes.Y;
        });
        const address1 = res.data.candidates.map((item) => {
          return item.address;
        });
        return axios
          .get(
            `${API_URL3}xmin%22%3A${X}%2C%22ymin%22%3A${Y}%2C%22xmax%22%3A${X}%2C%22ymax%22%3A${Y}%2C%22spatialReference%22%3A%7B%22wkid%22%3A103120%2C%22latestWkid%22%3A6539%7D%7D&geometryType=esriGeometryEnvelope&inSR=103120&outFields=OBJECTID%2CFIRST_NAME%2CLAST_NAME%2CPARCELID%2CADDR_NUMBER%2CSTREET%2CSTREET_TYPE%2CSTREET_DIR%2CCITY%2CMAIL_ZIP%2CACRE_CALULATED%2CSCHOOL_DISTRICT_ID%2CLAND_USE1%2COWNER_NAME%2CShape_Length%2CShape_Area&outSR=103120`
          )
          .then((data) => {
            if (data.data.features.length > 0) {
              this.setState({
                dist: data.data.features[0].attributes.PARCELID.slice(0, 4),

                sect:
                  data.data.features[0].attributes.PARCELID.slice(4, 9).substr(
                    0,
                    3
                  ) +
                  "." +
                  data.data.features[0].attributes.PARCELID.slice(4, 9).substr(
                    3
                  ),

                block:
                  data.data.features[0].attributes.PARCELID.slice(9, 14).substr(
                    0,
                    3
                  ) +
                  "." +
                  data.data.features[0].attributes.PARCELID.slice(9, 14).substr(
                    3
                  ),

                lot:
                  data.data.features[0].attributes.PARCELID.slice(
                    14,
                    19
                  ).substr(0, 3) +
                  "." +
                  data.data.features[0].attributes.PARCELID.slice(
                    14,
                    19
                  ).substr(3),

                building_owner_name:
                  data.data.features[0].attributes.OWNER_NAME !== null
                    ? data.data.features[0].attributes.OWNER_NAME
                    : "",

                category_code:
                  data.data.features.length > 0
                    ? data.data.features[0].attributes.LAND_USE1
                    : "N/A",
              });
            } else {
              this.setState({
                dist: "",
                sect: "",
                block: "",
                lot: "",
                building_owner_name: "",
              });
            }
          })
          .catch((err) => {
            console.log("AXIOS ERROR:"), err;
          })

          .then((res) => {
            return API.get(
              `certificate/get-land-use-type?code=${this.state.category_code}`
            )
              .then((item) => {
                this.setState({
                  building_use: item.data.type,
                });
              })
              .catch((err) => {
                console.log("AXIOS ERROR:"), err;
                this.setState({
                  building_use: "N/A",
                });
              });
          })
          .then((res) => {
            return API.get(`certificate/get-degrees-lat-long?x=${X}&y=${Y}`)
              .then((item) => {
                const res = item.data.data.DegreesMinutesSeconds.split(",").map(
                  (data) => {
                    return data;
                  }
                );
                this.state.lattitude = res[0];
                this.state.longitude = res[1];
                this.setState({
                  nad_data:
                    item.data.data.DegreesMinutesSeconds !== ""
                      ? "nad1983"
                      : "",
                });
              })
              .catch((err) => {
                console.log("AXIOS ERROR:"), err;
              });
          })
          .catch((err) => {
            console.log("AXIOS ERROR:"), err;
          })
          .then((res) => {
            return API.post(`certificate/get-flood-zone-data`, {
              address: getAddress[0],
            })
              .then((item) => {
                this.setState({
                  floodZone: item.data.data.FLD_ZONE
                    ? item.data.data.FLD_ZONE
                    : item.data.data,
                  stat_val: item.data.data.STATIC_BFE
                    ? item.data.data.STATIC_BFE
                    : "",
                  static_BFE:
                    this.state.stat_val !== "-9999" ? this.state.stat_val : "",
                  fz_other: item.data.data.STATIC_BFE
                    ? item.data.data.STATIC_BFE
                    : "",
                  bfe_depth: item.data.data.STATIC_BFE
                    ? item.data.data.STATIC_BFE
                    : "",
                  v_datum: item.data.data.V_DATUM ? item.data.data.V_DATUM : "",
                });
              })
              .catch((err) => {
                console.log("AXIOS ERROR:"), err;
              });
          })
          .catch((err) => {
            console.log("AXIOS ERROR:"), err;
          })
          .then((res) => {
            return API.get(
              `certificate/get-community-details?zip_code=${this.state.zipcode}`
            )
              .then((data) => {
                this.setState({
                  community_options: data.data,
                  county_name: data.data[0].county,
                });
              })
              .catch((err) => {
                console.log("AXIOS ERROR:"), err;
              });
          })

          .then((res) => {
            return API.post(`certificate/get-flood-zone`, {
              address: getAddress[0],
            })
              .then((item) => {
                this.setState({
                  flood_map_no: item.data.data.flood_map_no
                    ? item.data.data.flood_map_no
                    : "",
                  effective_date: item.data.data.effective_date
                    ? item.data.data.effective_date
                    : "",
                  firm_index_date: item.data.data.effective_date
                    ? item.data.data.effective_date
                    : "",

                  map_panel_no: item.data.data.map_panel_no,
                  suffix: item.data.data.suffix ? item.data.data.suffix : "",
                  isAddressVerify: false,
                });
              })
              .catch((err) => {
                console.log("AXIOS ERROR:"), err;
                this.setState({
                  isAddressVerify: false,
                });
              });
          })

          .catch((err) => {
            console.log("AXIOS ERROR:"), err;
            this.setState({
              isAddressVerify: false,
            });
          });
      })
      .catch((err) => {
        console.log("AXIOS ERROR:"), err;
        this.setState({
          isAddressVerify: false,
        });
      });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    try {
      if (
        sessionStorage.getItem("diagramdata") &&
        sessionStorage.getItem("diagram") &&
        sessionStorage.getItem("active_section")
      ) {
        var diagramdata = JSON.parse(sessionStorage.getItem("diagramdata"));
        this.setState({
          isLoggedUser: this.state.userId === userId ? true : false,
          answer1: diagramdata.answer1,
          answer9: diagramdata.answer9,
        });
        if (diagramdata.answer1 === "no" && diagramdata.answer9 === "yes") {
          this.setState({
            attached_garage_e3: "N/A",
            attached_garage_top_slab: "N/A",
          });
        } else if (
          diagramdata.answer9 === "no" &&
          diagramdata.answer1 === "yes"
        ) {
          this.setState({
            permanant_flood_openings: "N/A",
            top_of_next_floor: "N/A",
          });
        } else if (
          diagramdata.answer1 === "no" &&
          diagramdata.answer9 === "no"
        ) {
          this.setState({
            attached_garage_e3: "N/A",
            attached_garage_top_slab: "N/A",
            permanant_flood_openings: "N/A",
            top_of_next_floor: "N/A",
          });
        }
        API.post("user/profile/" + this.state.userId)
          .then((res) => {
            const profile = res.data.response;
            this.setState({
              cardData: profile.card,
              reviews: profile.review,
              profileData: profile.user[0],
              isDashboardLoading: false,

              certifier_name: profile.user[0].first_name,
              certifier_license_no: profile.user[0].license_no,
              certifier_designation: profile.user[0].designation,
              certifier_company: profile.user[0].name,
              certifier_address: profile.user[0].address,
              certifier_city: profile.user[0].city,
              user_state: profile.user[0].state,
              user_signature: profile.user[0].signature_image_url,
              user_zipcode: profile.user[0].zipcode,
              user_telephone: profile.user[0].mobile_no,
              user_ext: profile.user[0].ext,

              equipment:
                profile.user[0].equipments !== null
                  ? profile.user[0].equipments.split(",")
                  : null,
            });
          })
          .catch((err) => {
            console.log("AXIOS ERROR: ", err);
          });
        if (sessionStorage.getItem("certificate_id")) {
          this.setState({
            certificate_id: sessionStorage.getItem("certificate_id"),
          });
        } else {
          this.getCertficateNo();
        }

        //fill form data from session storage on reload
        var secA = JSON.parse(sessionStorage.getItem("sectionAdata"));
        if (secA) {
          Object.keys(secA).forEach((key) => {
            this.setState({
              [key]: secA[key],
            });
          });
        }
        var secB = JSON.parse(sessionStorage.getItem("sectionBdata"));
        if (secB) {
          Object.keys(secB).forEach((key) => {
            this.setState({
              [key]: secB[key],
            });
          });
        }
        var secC = JSON.parse(sessionStorage.getItem("sectionCdata"));
        if (secC) {
          Object.keys(secC).forEach((key) => {
            this.setState({
              [key]: secC[key],
            });
          });
        }
        var secD = JSON.parse(sessionStorage.getItem("sectionDdata"));
        if (secD) {
          Object.keys(secD).forEach((key) => {
            this.setState({
              [key]: secD[key],
            });
          });
        }
        var secE = JSON.parse(sessionStorage.getItem("sectionEdata"));
        if (secE) {
          Object.keys(secE).forEach((key) => {
            this.setState({
              [key]: secE[key],
            });
          });
        }
        var secF = JSON.parse(sessionStorage.getItem("sectionFdata"));
        if (secF) {
          Object.keys(secF).forEach((key) => {
            this.setState({
              [key]: secF[key],
            });
          });
        }
        var secG = JSON.parse(sessionStorage.getItem("sectionGdata"));
        if (secG) {
          Object.keys(secG).forEach((key) => {
            this.setState({
              [key]: secG[key],
            });
          });
        }
        var secH = JSON.parse(sessionStorage.getItem("sectionHdata"));
        if (secH) {
          Object.keys(secH).forEach((key) => {
            Object.keys(secH[key]).forEach((inkey) => {
              this.setState({
                [`${key}_${inkey}`]: secH[key][inkey],
              });
            });
          });
        }
      } else {
        this.props.history.push("/");
      }
    } catch (error) {
      console.log(error);
    }
  }
  componentWillUnmount() {
    if (this.state.currentstep !== 9 || this.state.isSubmitted !== "success") {
      MySwal.fire({
        // position: "top-end",
        icon: "success",
        title: "Your work has been saved",
        // showConfirmButton: false,
        timer: 1500,
      });
    }
    sessionStorage.clear();
  }
  stopLoading = () => {
    this.setState({
      isAddressVerify: false,
    });
  };

  getCertficateNo = () => {
    API.get(`certificate/get-next-certificate-no?user_id=${this.state.userId}`)
      .then((res) => {
        this.setState({ certificate_id: res.data.data.certificate_id });
        sessionStorage.setItem("certificate_id", res.data.data.certificate_id);
        this.saveDiagramData(res.data.data.certificate_id);
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };
  saveDiagramData = (certificate_id) => {
    API.post("certificate/save-diagram-data", {
      diagram: sessionStorage.getItem("diagram"),
      diagram_data: JSON.parse(sessionStorage.getItem("diagramdata")),
      user_id: this.state.userId,
      certificate_id: certificate_id,
      active_section: this.state.currentstep,
    })
      .then(async (res) => {
        console.log("diagram data saved");
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };
  handleChange = (event) => {
    const { name, value } = event.target;

    this.setState({
      [name]: value,

      // engineered_garage: value,
    });
  };
  removeTag = (i) => {
    const newequipments = [...this.state.equipment];
    newequipments.splice(i, 1);
    this.setState({ equipment: newequipments });
  };

  inputKeyDown = (e) => {
    const val = e.target.value;

    if (e.key === "Enter" && val) {
      if (
        this.state.equipment.find(
          (tag) => tag.toLowerCase() === val.toLowerCase()
        )
      ) {
        return;
      }
      this.setState({
        equipment: [...this.state.equipment, val],
      });

      this.tagInput.value = null;
    } else if (e.key === "Backspace" && !val) {
      this.removeTag(this.state.equipment.length - 1);
    }
  };
  handleSubmitAll = (event) => {
    const certificateData = {
      certificate_id: this.state.certificate_id,
      user_id: this.state.userId,
      status: "completed",
    };

    event.preventDefault();
    API.post("certificate/save-certificate", certificateData)
      .then(async (res) => {
        if (res.status === 200) {
          this.setState({
            isSubmitted: "success",
          });
          sessionStorage.setItem("form_isSubmitted", "success");
        } else {
          this.setState({
            isSubmitted: "fail",
          });
        }
      })
      .catch((err) => {
        console.log("AXIOS ERROR", err);
        this.setState({
          isSubmitted: "fail",
        });
      });
  };
  handleSubmit = (event, sectionData, stepno, data, sectionName) => {
    event.preventDefault();

    if (this.state.local_officials_community_name === "") {
      this.setState({
        local_officials_community_name: this.state.community_name,
      });
    } else {
      this.setState({
        local_officials_community_name: this.state
          .local_officials_community_name,
      });
    }

    if (stepno === 1) {
      if (this.validator1.allValid()) {
        let currentstep = stepno;
        this.setState({ loading: true });
        API.post("certificate/save-certificate-section", sectionData)
          .then(async (res) => {
            if (res.status === 200) {
              sessionStorage.setItem(
                sectionName,
                JSON.stringify(data.section_data)
              );
              if (
                currentstep === 2 &&
                (this.state.floodZone === "AO" || this.state.floodZone === "A")
              ) {
                currentstep = 5;
              } else if (
                currentstep === 4 &&
                (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
              ) {
                currentstep = 7;
              } else {
                currentstep = currentstep + 1;
              }
              this.setState({
                currentstep: currentstep,
                isSubmittedA: true,
                loading: false,
              });
              sessionStorage.setItem("active_section", currentstep);
            }
          })
          .catch((err) => {
            console.log("AXIOS ERROR", err);
            this.setState({
              isSubmittedA: false,
            });
          });
      } else {
        this.validator1.showMessages();
        this.forceUpdate();
      }
    } else if (stepno === 2) {
      if (this.validator2.allValid()) {
        let currentstep = stepno;
        this.setState({ loading: true });
        API.post("certificate/save-certificate-section", sectionData)
          .then(async (res) => {
            if (res.status === 200) {
              sessionStorage.setItem(
                sectionName,
                JSON.stringify(data.section_data)
              );
              if (
                currentstep === 2 &&
                (this.state.floodZone === "AO" || this.state.floodZone === "A")
              ) {
                currentstep = 5;
              } else if (
                currentstep === 4 &&
                (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
              ) {
                currentstep = 7;
              } else {
                currentstep = currentstep + 1;
              }
              this.setState({
                currentstep: currentstep,
                isSubmittedB: true,
                loading: false,
              });
              sessionStorage.setItem("active_section", currentstep);
            }
          })
          .catch((err) => {
            console.log("AXIOS ERROR", err);
            this.setState({
              isSubmittedB: false,
            });
          });
      } else {
        this.validator2.showMessages();
        this.forceUpdate();
      }
    } else if (stepno === 3) {
      if (this.validator3.allValid()) {
        let currentstep = stepno;
        this.setState({ loading: true });
        API.post("certificate/save-certificate-section", sectionData)
          .then(async (res) => {
            if (res.status === 200) {
              sessionStorage.setItem(
                sectionName,
                JSON.stringify(data.section_data)
              );
              if (
                currentstep === 2 &&
                (this.state.floodZone === "AO" || this.state.floodZone === "A")
              ) {
                currentstep = 5;
              } else if (
                currentstep === 4 &&
                (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
              ) {
                currentstep = 7;
              }
              // else if(currentstep >= 7) {
              //   currentstep = currentstep + 1;
              // }
              else {
                currentstep = currentstep + 1;
              }
              this.setState({
                currentstep: currentstep,
                isSubmittedC: true,
                loading: false,
              });
              sessionStorage.setItem("active_section", currentstep);
            }
          })
          .catch((err) => {
            console.log("AXIOS ERROR", err);
            this.setState({
              isSubmittedC: false,
            });
          });
      } else {
        this.validator3.showMessages();

        this.forceUpdate();
      }
    } else if (stepno === 4) {
      if (this.validator4.allValid()) {
        let currentstep = stepno;
        this.setState({ loading: true });
        API.post("certificate/save-certificate-section", sectionData)
          .then(async (res) => {
            if (res.status === 200) {
              sessionStorage.setItem(
                sectionName,
                JSON.stringify(data.section_data)
              );
              if (
                currentstep === 2 &&
                (this.state.floodZone === "AO" || this.state.floodZone === "A")
              ) {
                currentstep = 5;
              } else if (
                currentstep === 4 &&
                (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
              ) {
                currentstep = 7;
              }
              // else if(currentstep >= 7) {
              //   currentstep = currentstep + 1;
              // }
              else {
                currentstep = currentstep + 1;
              }
              this.setState({
                currentstep: currentstep,
                isSubmittedD: true,
                loading: false,
              });
              sessionStorage.setItem("active_section", currentstep);
            }
          })
          .catch((err) => {
            console.log("AXIOS ERROR", err);
            this.setState({
              isSubmittedD: false,
            });
          });
      } else {
        this.validator4.showMessages();

        this.forceUpdate();
      }
    } else if (stepno === 5) {
      if (this.validator5.allValid()) {
        let currentstep = stepno;
        this.setState({ loading: true });
        API.post("certificate/save-certificate-section", sectionData)
          .then(async (res) => {
            if (res.status === 200) {
              sessionStorage.setItem(
                sectionName,
                JSON.stringify(data.section_data)
              );
              if (
                currentstep === 2 &&
                (this.state.floodZone === "AO" || this.state.floodZone === "A")
              ) {
                currentstep = 5;
              } else if (
                currentstep === 4 &&
                (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
              ) {
                currentstep = 7;
              } else {
                currentstep = currentstep + 1;
              }
              this.setState({
                currentstep: currentstep,
                isSubmittedE: true,
                loading: false,
              });
              sessionStorage.setItem("active_section", currentstep);
            }
          })
          .catch((err) => {
            console.log("AXIOS ERROR", err);
            this.setState({
              isSubmittedE: false,
            });
          });
      } else {
        this.validator5.showMessages();

        this.forceUpdate();
      }
    } else if (stepno === 6) {
      if (this.validator6.allValid()) {
        let currentstep = stepno;
        this.setState({ loading: true });
        API.post("certificate/save-certificate-section", sectionData)
          .then(async (res) => {
            if (res.status === 200) {
              sessionStorage.setItem(
                sectionName,
                JSON.stringify(data.section_data)
              );
              if (
                currentstep === 2 &&
                (this.state.floodZone === "AO" || this.state.floodZone === "A")
              ) {
                currentstep = 5;
              } else if (
                currentstep === 4 &&
                (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
              ) {
                currentstep = 7;
              } else {
                currentstep = currentstep + 1;
              }
              this.setState({
                currentstep: currentstep,
                isSubmittedF: true,
                loading: false,
              });
              sessionStorage.setItem("active_section", currentstep);
            }
          })
          .catch((err) => {
            console.log("AXIOS ERROR", err);
            this.setState({
              isSubmittedF: false,
            });
          });
      } else {
        this.validator6.showMessages();

        this.forceUpdate();
      }
    } else if (stepno === 7) {
      if (this.validator7.allValid()) {
        let currentstep = stepno;
        this.setState({ loading: true });
        API.post("certificate/save-certificate-section", sectionData)
          .then(async (res) => {
            if (res.status === 200) {
              sessionStorage.setItem(
                sectionName,
                JSON.stringify(data.section_data)
              );
              if (
                currentstep === 2 &&
                (this.state.floodZone === "AO" || this.state.floodZone === "A")
              ) {
                currentstep = 5;
              } else if (
                currentstep === 4 &&
                (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
              ) {
                currentstep = 7;
              } else {
                currentstep = currentstep + 1;
              }
              this.setState({
                currentstep: currentstep,
                isSubmittedG: true,
                loading: false,
              });
              sessionStorage.setItem("active_section", currentstep);
            }
          })
          .catch((err) => {
            console.log("AXIOS ERROR", err);
            this.setState({
              isSubmittedG: false,
            });
          });
      } else {
        this.validator7.showMessages();

        this.forceUpdate();
      }
    } else if (stepno === 8) {
      if (this.validator8.allValid()) {
        let currentstep = stepno;
        this.setState({ loading: true });
        API.post("certificate/save-certificate-section", sectionData)
          .then(async (res) => {
            if (res.status === 200) {
              sessionStorage.setItem(
                sectionName,
                JSON.stringify(data.section_data)
              );
              if (
                currentstep === 2 &&
                (this.state.floodZone === "AO" || this.state.floodZone === "A")
              ) {
                currentstep = 5;
              } else if (
                currentstep === 4 &&
                (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
              ) {
                currentstep = 7;
              } else {
                currentstep = currentstep + 1;
              }
              this.setState({
                currentstep: currentstep,
                isSubmittedH: true,
                status: "completed",
                loading: false,
              });
              sessionStorage.setItem("section_status", "completed");
              sessionStorage.setItem("active_section", currentstep);
            }
          })
          .catch((err) => {
            console.log("AXIOS ERROR", err);
            this.setState({
              isSubmittedH: false,
            });
          });
      } else {
        this.validator8.showMessages();

        this.forceUpdate();
      }
    }
  };
  _next = (event) => {
    let currentstep = this.state.currentstep;
    let active_section = currentstep + 1;

    // setting active steps according to the skip logic
    if (
      currentstep === 2 &&
      (this.state.floodZone === "AO" || this.state.floodZone === "A")
    ) {
      active_section = 5;
    } else if (
      currentstep === 4 &&
      (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
    ) {
      active_section = 7;
    } else {
      active_section = currentstep + 1;
    }

    const sectionA = {
      certificate_id: this.state.certificate_id,
      user_id: this.state.userId,
      section_letter: "A",
      active_section: active_section,
      section_data: {
        building_owner_name: this.state.building_owner_name,
        building_street_address: this.state.addressLine.text,
        addressLine: this.state.addressLine,
        city: this.state.city,
        region: this.state.region,
        zipcode: this.state.zipcode,
        dist: this.state.dist,
        sect: this.state.sect,
        block: this.state.block,
        lot: this.state.lot,
        building_use: this.state.building_use,
        lattitude: this.state.lattitude,
        longitude: this.state.longitude,
        nad_data: this.state.nad_data,
        bulding_diagram_no: sessionStorage.getItem("diagram"),
        sq_ft_crawlspace: this.state.sq_ft_crawlspace,
        flood_opening_crawlspace: this.state.flood_opening_crawlspace,
        net_area_crawlspace: this.state.net_area_crawlspace,
        engineered_crawlspace: this.state.engineered_crawlspace,
        sq_ft_garage: this.state.sq_ft_garage,
        flood_opening_garage: this.state.flood_opening_garage,
        net_area_garage: this.state.net_area_garage,
        engineered_garage: this.state.engineered_garage,
      },
    };
    var sectionDataA = new FormData();
    Object.keys(sectionA).forEach((key) => {
      if (key !== "section_data") {
        sectionDataA.append(key, sectionA[key]);
      } else {
        sectionDataA.append(key, JSON.stringify(sectionA[key]));
      }
    });

    const sectionB = {
      certificate_id: this.state.certificate_id,
      user_id: this.state.userId,
      section_letter: "B",
      active_section: active_section,
      section_data: {
        community_name: this.state.community_name,
        community_options: this.state.community_options,
        county_name: this.state.county_name,
        region: this.state.region,
        map_panel_no: this.state.map_panel_no,
        suffix: this.state.suffix,
        firm_index_date: this.state.firm_index_date,
        effective_date: this.state.effective_date,
        floodZone: this.state.floodZone,
        static_BFE: this.state.static_BFE,
        fz_source: this.state.fz_source,
        fz_other: this.state.static_BFE,
        elevation_datum: this.state.elevation_datum,
        v_datum: this.state.v_datum,
        isLocation: this.state.isLocation,
        designation_date: this.state.designation_date,
        building_location_area: this.state.building_location_area,
      },
    };
    var sectionDataB = new FormData();
    Object.keys(sectionB).forEach((key) => {
      if (key !== "section_data") {
        sectionDataB.append(key, sectionB[key]);
      } else {
        sectionDataB.append(key, JSON.stringify(sectionB[key]));
      }
    });

    const sectionC = {
      certificate_id: this.state.certificate_id,
      user_id: this.state.userId,
      section_letter: "C",
      active_section: active_section,
      section_data: {
        building_based: this.state.building_based,
        benchmark_utl: this.state.benchmark_utl,
        vertical_datum: this.state.vertical_datum,
        elevation_item: this.state.elevation_item,
        elevation_other: this.state.elevation_other,
        top_of_bottom_floor: this.state.top_of_bottom_floor,
        top_of_bottom_floor_unit: this.state.top_of_bottom_floor_unit,
        top_of_next_floor: this.state.top_of_next_floor,
        top_of_next_floor_unit: this.state.top_of_next_floor_unit,
        bottom_of_lowest_member: this.state.bottom_of_lowest_member,
        bottom_of_lowest_member_unit: this.state.bottom_of_lowest_member_unit,
        attached_garage: this.state.attached_garage,
        attached_garage_unit: this.state.attached_garage_unit,
        attached_garage_top_slab: this.state.attached_garage_top_slab,
        attached_garage_top_slab_unit: this.state.attached_garage_top_slab_unit,
        lowest_elevation: this.state.lowest_elevation,
        lowest_elevation_unit: this.state.lowest_elevation_unit,
        lowest_adjacent: this.state.lowest_adjacent,
        lowest_adjacent_unit: this.state.lowest_adjacent_unit,
        highest_adjacent: this.state.highest_adjacent,
        highest_adjacent_unit: this.state.highest_adjacent_unit,
        lowest_adjacent_grade: this.state.lowest_adjacent_grade,
        lowest_adjacent_grade_unit: this.state.lowest_adjacent_grade_unit,
      },
    };
    var sectionDataC = new FormData();
    Object.keys(sectionC).forEach((key) => {
      if (key !== "section_data") {
        sectionDataC.append(key, sectionC[key]);
      } else {
        sectionDataC.append(key, JSON.stringify(sectionC[key]));
      }
    });

    const sectionD = {
      certificate_id: this.state.certificate_id,
      user_id: this.state.userId,
      section_letter: "D",
      active_section: active_section,
      section_data: {
        Islicensed_surveyor: this.state.Islicensed_surveyor,
        certifier_name: this.state.certifier_name,
        certifier_license_no: this.state.certifier_license_no,
        certifier_designation: this.state.certifier_designation,
        certifier_company: this.state.certifier_company,
        certifier_address: this.state.certifier_address,
        certifier_city: this.state.certifier_city,
        user_state: this.state.user_state,
        user_signature: this.state.user_signature,
        user_zipcode: this.state.user_zipcode,
        user_telephone: this.state.user_telephone,
        user_ext: this.state.user_ext,
        user_date: this.state.user_date,
        equipment: this.state.equipment,
        comments_for_D: this.state.comments_for_D,
      },
    };

    var sectionDataD = new FormData();
    Object.keys(sectionD).forEach((key) => {
      if (key !== "section_data") {
        sectionDataD.append(key, sectionD[key]);
      } else {
        sectionDataD.append(key, JSON.stringify(sectionD[key]));
      }
    });
    // this.state.surveyor_sign.map((file, i) => {
    //   sectionDataD.append("user_signature[]", file, file.name);
    //   return 0;
    // });
    this.state.survey_attachment.map((file, i) => {
      sectionDataD.append("survey_attachment[]", file, file.name);
      return 0;
    });

    const sectionE = {
      certificate_id: this.state.certificate_id,
      user_id: this.state.userId,
      section_letter: "E",
      active_section: active_section,
      section_data: {
        elevation_hag: this.state.elevation_hag,
        elevation_hag_unit: this.state.elevation_hag_unit,
        elevation_lag: this.state.elevation_lag,
        elevation_lag_unit: this.state.elevation_lag_unit,
        permanant_flood_openings: this.state.permanant_flood_openings,
        permanant_flood_openings_unit: this.state.permanant_flood_openings_unit,
        attached_garage_e3: this.state.attached_garage_e3,
        attached_garage_e3_unit: this.state.attached_garage_e3_unit,
        equipment_serving: this.state.equipment_serving,
        equipment_serving_unit: this.state.equipment_serving_unit,
        floodplainmgt: this.state.floodplainmgt,
      },
    };
    var sectionDataE = new FormData();
    Object.keys(sectionE).forEach((key) => {
      if (key !== "section_data") {
        sectionDataE.append(key, sectionE[key]);
      } else {
        sectionDataE.append(key, JSON.stringify(sectionE[key]));
      }
    });

    const sectionF = {
      certificate_id: this.state.certificate_id,
      user_id: this.state.userId,
      section_letter: "F",
      active_section: active_section,
      section_data: {
        building_owner_name: this.state.building_owner_name,
        owner_address: this.state.addressLine.text,
        city: this.state.city,
        region: this.state.region,
        zipcode: this.state.zipcode,
        owner_signature: this.state.owner_signature,
        owner_sign_date: this.state.owner_sign_date,
        owner_telephone: this.state.owner_telephone,
        owner_comments: this.state.owner_comments,
      },
    };
    var sectionDataF = new FormData();
    Object.keys(sectionF).forEach((key) => {
      if (key !== "section_data") {
        sectionDataF.append(key, sectionF[key]);
      } else {
        sectionDataF.append(key, JSON.stringify(sectionF[key]));
      }
    });

    this.state.property_attachment.map((file, i) => {
      sectionDataF.append("property_attachment[]", file, file.name);
      return 0;
    });

    const sectionG = {
      certificate_id: this.state.certificate_id,
      user_id: this.state.userId,
      section_letter: "G",
      active_section: active_section,
      section_data: {
        comunity_item: [
          {
            item_one: this.state.item_g1,
            item_two: this.state.item_g2,
            item_three: this.state.item_g3,
          },
        ],

        permit_no: this.state.permit_no,
        permit_issues_for: this.state.permit_issues_for,
        date_certificate_compliance: this.state.date_certificate_compliance,
        permit_case: this.state.permit_case,
        basement_elevation: this.state.basement_elevation,
        basement_elevation_unit: this.state.basement_elevation_unit,
        basement_elevation_datum: this.state.basement_elevation_datum,
        bfe_depth: this.state.static_BFE,
        bfe_depth_unit: this.state.bfe_depth_unit,
        bfe_depth_datum: this.state.bfe_depth_datum,
        community_design: this.state.community_design,
        community_design_unit: this.state.community_design_unit,
        community_design_datum: this.state.community_design_datum,
        local_officials_name: this.state.local_officials_name,
        local_officials_title: this.state.local_officials_title,
        local_officials_community_name: this.state
          .local_officials_community_name,
        local_officials_telephoe: this.state.local_officials_telephoe,
        local_officials_signature: this.state.local_officials_signature,
        local_officials_date: this.state.local_officials_date,
        comment_for_community: this.state.comment_for_community,
      },
    };
    var sectionDataG = new FormData();
    Object.keys(sectionG).forEach((key) => {
      if (key !== "section_data") {
        sectionDataG.append(key, sectionG[key]);
      } else {
        sectionDataG.append(key, JSON.stringify(sectionG[key]));
      }
    });

    // sectionDataG.append("section_data", JSON.stringify(sectionG));

    const sectionH = {
      certificate_id: this.state.certificate_id,
      user_id: this.state.userId,
      section_letter: "H",
      active_section: active_section,
      section_data: {
        front_view: {
          caption: this.state.front_view_caption,
          date: this.state.front_view_date,
        },
        rear_view: {
          caption: this.state.rear_view_caption,
          date: this.state.rear_view_date,
        },
        right_view: {
          caption: this.state.right_view_caption,
          date: this.state.right_view_date,
        },
        left_view: {
          caption: this.state.left_view_caption,
          date: this.state.left_view_date,
        },
      },
    };
    var sectionDataH = new FormData();
    Object.keys(sectionH).forEach((key) => {
      if (key !== "section_data") {
        sectionDataH.append(key, sectionH[key]);
      } else {
        sectionDataH.append(key, JSON.stringify(sectionH[key]));
      }
    });

    // sectionDataH.append("section_data", JSON.stringify(sectionH));

    this.state.front_view_img.map((file, i) => {
      sectionDataH.append("front_view_img[]", file, file.name);
      return 0;
    });
    this.state.rear_view_img.map((file, i) => {
      sectionDataH.append("rear_view_img[]", file, file.name);
      return 0;
    });
    this.state.right_view_img.map((file, i) => {
      sectionDataH.append("right_view_img[]", file, file.name);
      return 0;
    });
    this.state.left_view_img.map((file, i) => {
      sectionDataH.append("left_view_img[]", file, file.name);
      return 0;
    });

    if (currentstep === 1) {
      this.handleSubmit(event, sectionDataA, 1, sectionA, "sectionAdata");
      this.handleSubmit(event, sectionDataB, 1, sectionB, "sectionBdata");
    } else if (currentstep === 2) {
      if (this.state.floodZone === "AO" || this.state.floodZone === "A") {
        this.handleSubmit(event, sectionDataB, 2, sectionB, "sectionBdata");
        this.handleSubmit(event, sectionDataC, 2, sectionC, "sectionCdata");
        this.handleSubmit(event, sectionDataD, 2, sectionD, "sectionDdata");
      } else {
        this.handleSubmit(event, sectionDataB, 2, sectionB, "sectionBdata");
      }
    } else if (currentstep === 3) {
      this.handleSubmit(event, sectionDataC, 3, sectionC, "sectionCdata");
    } else if (currentstep === 4) {
      if (this.state.floodZone !== "AO" || this.state.floodZone !== "A") {
        this.handleSubmit(event, sectionDataD, 4, sectionD, "sectionDdata");
        this.handleSubmit(event, sectionDataE, 4, sectionE, "sectionEdata");
        this.handleSubmit(event, sectionDataF, 4, sectionF, "sectionFdata");
      } else {
        this.handleSubmit(event, sectionDataD, 4, sectionD, "sectionDdata");
      }
    } else if (currentstep === 5) {
      this.handleSubmit(event, sectionDataE, 5, sectionE, "sectionEdata");
    } else if (currentstep === 6) {
      this.handleSubmit(event, sectionDataF, 6, sectionF, "sectionFdata");
    } else if (currentstep === 7) {
      this.handleSubmit(event, sectionDataG, 7, sectionG, "sectionGdata");
    } else if (currentstep === 8) {
      this.handleSubmit(event, sectionDataH, 8, sectionH, "sectionHdata");
    } else {
      this.setState({
        pageA: true,
      });
    }

    window.scrollTo(0, 0);
    // let currentstep = this.state.currentstep;
    // this.setState({
    //   currentstep: currentstep >= 7 ? 8 : currentstep + 1,
    // });
  };

  _prev = () => {
    window.scrollTo(0, 0);
    let currentstep = this.state.currentstep;

    if (currentstep <= 4) {
      this.setState({
        currentstep: currentstep - 1,
      });
      sessionStorage.setItem("active_section", currentstep - 1);
    } else if (
      currentstep === 5 &&
      (this.state.floodZone === "AO" || this.state.floodZone === "A")
    ) {
      this.setState({
        currentstep: currentstep - 3,
      });
      sessionStorage.setItem("active_section", currentstep - 3);
    } else if (currentstep === 6) {
      this.setState({
        currentstep: currentstep - 1,
      });
      sessionStorage.setItem("active_section", currentstep - 1);
    } else if (
      currentstep === 7 &&
      (this.state.floodZone === "AO" || this.state.floodZone === "A")
    ) {
      this.setState({
        currentstep: currentstep - 1,
      });
      sessionStorage.setItem("active_section", currentstep - 1);
    } else if (
      currentstep === 6 &&
      (this.state.floodZone === "AO" || this.state.floodZone === "A")
    ) {
      this.setState({
        currentstep: currentstep - 4,
      });
    } else if (
      currentstep === 7 &&
      (this.state.floodZone !== "AO" || this.state.floodZone !== "A")
    ) {
      this.setState({
        currentstep: currentstep - 3,
      });
      sessionStorage.setItem("active_section", currentstep - 3);
    } else {
      this.setState({
        currentstep: currentstep - 1,
      });
      sessionStorage.setItem("active_section", currentstep - 1);
    }
    // currentstep = currentstep <= 1 ? 1 : currentstep - 1;
    // this.setState({
    //   currentstep: currentstep,
    // });
  };

  /*
   * the functions for our button
   */
  previousButton() {
    let currentstep = this.state.currentstep;
    let isSubmitted = this.state.isSubmitted;
    if (currentstep !== 1 && isSubmitted !== "success") {
      return (
        <button className="btn-previous" type="button" onClick={this._prev}>
          Back
        </button>
      );
    }
    return null;
  }

  nextButton() {
    let currentstep = this.state.currentstep;
    if (currentstep < 9) {
      return (
        <button className="btn-next" type="button" onClick={this._next}>
          Next
        </button>
      );
    }

    return null;
  }

  render() {
    let imgPreview;
    if (this.state.file) {
      imgPreview = <img src={this.state.file} alt="" />;
    }

    const { classes } = this.props;
    const { details } = this.props;

    const { diagram } = this.props;
    return (
      <div className="">
        <div className="main-form-eleveation">
          <div className="breadCrumb">
            <Link to="/" className="prevLinks">
              Dashboard
            </Link>
            <span>&nbsp;&gt;&nbsp;</span>
            <Link className="prevLinks" to={`/Questionnaire/${userId}`}>
              Questionnaire
            </Link>
            <span>&nbsp;&gt;&nbsp;</span>
            <span className="currLink">Elevation Certificate </span>
          </div>
          <div>
            <TabComponents stepValue={this.state.currentstep} />
          </div>
          <div>
            <form onSubmit={(e) => e.preventDefault()}>
              {this.state.currentstep === 1 ? (
                <div currentstep={1}>
                  {/* SECTION A */}
                  {sessionStorage.getItem("diagram") && (
                    <SectionA
                      sectionA={this.state}
                      onClickA={this.handleChange}
                      validateA={this.validator1}
                      getlocation={this.getLocationDetails}
                      stoploading={this.stopLoading}
                    />
                  )}
                </div>
              ) : this.state.currentstep === 2 ? (
                //SECTION B
                this.state.loading ? (
                  <Loader />
                ) : (
                  <SectionB
                    sectionB={this.state}
                    onClickB={this.handleChange}
                    onChangeCounty={this.onChangeCommunity}
                    validateB={this.validator2}
                  />
                )
              ) : this.state.currentstep === 3 ? (
                //SECTION C
                this.state.loading ? (
                  <Loader />
                ) : (
                  <SectionC
                    sectionC={this.state}
                    onClickC={this.handleChange}
                    validateC={this.validator3}
                  />
                )
              ) : this.state.currentstep === 4 ? (
                //SECTION D
                this.state.loading ? (
                  <Loader />
                ) : (
                  <SectionD
                    sectionD={this.state}
                    onClickD={this.handleChange}
                    validateD={this.validator4}
                    imagedata={this.imagestate}
                    removeTag={this.removeTag}
                    inputKeyDown={this.inputKeyDown}
                  />
                )
              ) : this.state.currentstep === 5 ? (
                // SECTION E
                this.state.loading ? (
                  <Loader />
                ) : (
                  <SectionE
                    sectionE={this.state}
                    onClickE={this.handleChange}
                    validateE={this.validator5}
                  />
                )
              ) : this.state.currentstep === 6 ? (
                //SECTION F
                this.state.loading ? (
                  <Loader />
                ) : (
                  <SectionF
                    sectionF={this.state}
                    onClickF={this.handleChange}
                    validateF={this.validator6}
                    imagedata={this.onChangeProperty}
                  />
                )
              ) : // <h2>step6</h2>
              this.state.currentstep === 7 ? (
                //SECTION G
                this.state.loading ? (
                  <Loader />
                ) : (
                  <SectionG
                    sectionG={this.state}
                    onClickG={this.handleChange}
                    validateG={this.validator7}
                  />
                )
              ) : this.state.currentstep === 8 ? (
                //SECTION H
                this.state.loading ? (
                  <Loader />
                ) : (
                  <SectionH
                    sectionH={this.state}
                    onClickH={this.handleChange}
                    validateH={this.validator8}
                    frontView={this.fronViewState}
                    rearView={this.rearViewState}
                    rightView={this.rightViewState}
                    leftView={this.leftViewState}
                  />
                )
              ) : this.state.currentstep === 9 &&
                this.state.status === "completed" ? (
                //SECTION I
                <div className="form-wrapper-elevation">
                  {this.state.isSubmitted === "success" ? (
                    <div className="sucess-message-content">
                      <h4>
                        Thanks for filling out
                        <strong> ELEVATION CERTIFICATE FORM.</strong>
                      </h4>
                      <p>
                        Go to your
                        <Link className="currLink" to={`/Profile/${userId}`}>
                          <span>profile</span>
                        </Link>
                        to download the Elevation Certificate
                      </p>
                    </div>
                  ) : (
                    <div>
                      {this.state.isSubmitted === "fail" ? (
                        <div className="err-msg-content">
                          Something went wrong. Please try again.
                        </div>
                      ) : null}
                      <h3>You cannot edit the form after you submit</h3>
                      <div className="submit-btn-block">
                        <button
                          className="btn-submit"
                          onClick={this.handleSubmitAll}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ) : null}
              <div className="btn-section">
                {this.previousButton()}
                {this.nextButton()}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

ElevationForm.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withRouter(withStyles(styles)(ElevationForm));



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/ElevationForm.js